import React, { useState } from "react";
import PageHeading from "../../CustomComponents/PageHeading";
import * as constants from "../../../constants";
import { IonButton, IonCol, IonDatetime, IonImg, IonInput, IonItem, IonLabel } from "@ionic/react";
import {
  COLLECTIONS,
  getSubCollectionDocument,
  saveDocumentData,
  uploadImageToFireStorage,
} from "../../../firebase";
import { connect } from "react-redux";
import {
  updateUserDocuments,
  userDocuments,
  updateUserVehicleDocuments,
} from "../../../Store/Actions/userInfo";
import { CustomIonImage } from "../../CustomComponents/IonImg";
import { Camera, CameraOptions } from "@ionic-native/camera";
import firebase from "firebase";

const AddPUCC: React.FC = (props: any) => {
  const [state, setState] = useState({
    documentId: "",
    documentType: "PUCC",
    expirationDate: "",
    puccNumber: "",
    frontDocumentImage: "",
    backDocumentImage: "",
    did: "",
  });
  React.useEffect(() => {
    if (!!props.location.state && Object.keys(props.location.state.userPUCCData || {}).length) {
      const data = props.location.state.userPUCCData;
      setState({
        documentId: data.documentId,
        documentType: data.documentType,
        expirationDate: data.expirationDate,
        puccNumber: data.additionalFields.puccNumber,
        frontDocumentImage: data.images[0],
        backDocumentImage: data.images[1],
        did: data.did,
      });
    }
    return () => {
      setState({
        documentId: "",
        documentType: "PUCC",
        expirationDate: "",
        puccNumber: "",
        frontDocumentImage: "",
        backDocumentImage: "",
        did: "",
      });
    };
  }, [props.userDocumentsList]);

  const handleChange = (key: any, value: any) => {
    setState({
      ...state,
      [key]: value,
    });
  };

  const handleFileUpload = async (event: any, imageType: string) => {
    const file = event.target.files[0];
    const updatedFileName = `${file.name} ${Date.now()}`;
    const response: any = await uploadImageToFireStorage(
      props.uid,
      file,
      updatedFileName,
      "documents",
    );
    setState({
      ...state,
      [imageType]: response.snapshot.metadata.fullPath,
    });
  };

  const saveDocuments = async () => {
    try {
      const vehicleData: any = await getSubCollectionDocument(
        props.uid,
        COLLECTIONS.USERS,
        COLLECTIONS.VECHICLES,
        props.location.state.vehicleId,
      );
      const {
        documentType = "INSURANCE",
        expirationDate = "",
        puccNumber = "",
        frontDocumentImage = "",
        backDocumentImage = "",
      } = state;
      const payload = {
        documentId: state.puccNumber,
        documentType: state.documentType,
        expirationDate: state.expirationDate,
        additionalFields: {
          puccNumber: state.puccNumber,
        },
        images: [state.frontDocumentImage, state.backDocumentImage],
      };
      const id: any = await saveDocumentData(
        props.uid,
        payload,
        COLLECTIONS.USERS,
        COLLECTIONS.DOCUMENTS,
        state.did || "",
      );
      !!state.did
        ? await props.updateUserDocuments({
            ...payload,
            did: state.did,
          })
        : await props.userDocuments([{ ...payload, did: id.did }]);
      !!!state.did &&
        (await saveDocumentData(
          props.uid,
          {
            ...vehicleData.data,
            documentIds: [
              ...vehicleData.data.documentIds,
              `users/${props.uid}/documents/${id.did}`,
            ],
          },
          COLLECTIONS.USERS,
          COLLECTIONS.VECHICLES,
          props.location.state.vehicleId,
        ));
      !!!state.did &&
        (await props.updateUserVehicleDocuments(
          props.location.state.vehicleId,
          `users/${props.uid}/documents/${id.did}`,
        ));
      props.history.goBack();
    } catch (e: any) {
      // alert(e);
      console.error("PUC - 138", e);
    }
  };

  const options: CameraOptions = {
    destinationType: Camera.DestinationType.DATA_URL,
    sourceType: Camera.PictureSourceType.SAVEDPHOTOALBUM,
    mediaType: Camera.MediaType.ALLMEDIA,
  };

  const AccessNativeCamera = (imageType: any) => {
    Camera.getPicture(options).then(
      async (imageData) => {
        let base64Image = "data:image/jpeg;base64," + imageData;
        const res = firebase
          .storage()
          .ref()
          .child(`${props.uid}/${"documents"}/${Date.now()}`)
          .putString(base64Image, "data_url", { contentType: "image/jpeg" });
        setState({
          ...state,
          [imageType]: `${props.uid}/${"documents"}/${Date.now()}`,
        });
      },
      (err: any) => {
        console.error(err, "CamError");
      },
    );
  };

  return (
    <IonCol className="middle_panle" size-md="6">
      <div className="document-main-div">
        <PageHeading mainHeader={constants.ADD_VIRTUAL_PUCC} navigation={props} />
        <div className="upload-documents-div">
          <div className="documents-information-div">
            <IonLabel color="secondary" className="document-item-label">
              {constants.PUCC_NUMBER}
            </IonLabel>
            <IonInput
              className="input-field"
              color="tertiary"
              placeholder={constants.ENTER_PUCC_NUMBER}
              value={state.puccNumber}
              onIonChange={(event: any) => {
                handleChange("puccNumber", event.detail.value);
              }}
            />
          </div>
          <div className="documents-information-div">
            <IonLabel color="secondary" className="document-item-label">
              {constants.EXPIRY_DATE}
            </IonLabel>
            <div className="calender">
              <IonInput
                className="calender-input calender-item"
                color="tertiary"
                placeholder={constants.DATE}
                readonly={true}
                value={new Date(state.expirationDate).getDate() || ""}
              />
              <IonInput
                className="calender-input calender-item"
                color="tertiary"
                placeholder={constants.MONTH}
                readonly={true}
                value={new Date(state.expirationDate).getMonth() || ""}
              />
              <IonInput
                className="calender-input calender-item"
                color="tertiary"
                placeholder={constants.YEAR}
                readonly={true}
                value={new Date(state.expirationDate).getFullYear() || ""}
              />
              <IonDatetime
                id="contained-button-file"
                class="date-picker"
                displayFormat="DD MM YYYY"
                placeholder="Select Date"
                // value={state.expirationDate}
                style={
                  {
                    // display: "none",
                  }
                }
                onIonChange={(event: any) => handleChange("expirationDate", event.detail.value)}
              ></IonDatetime>
              <label htmlFor="contained-button-file">
                <IonImg
                  className="calender-img"
                  src="/images/calendar1.svg"
                  alt="calendar"
                  onClick={() => document.getElementById("contained-button-file")}
                />
              </label>
            </div>
          </div>
          <div className="documents-information-div">
            <IonLabel color="secondary" className="document-item-label">
              {constants.IMAGES}
            </IonLabel>
            <div className="upload-documents">
              <div
                className="upload-rc-documents"
                onClick={() => AccessNativeCamera("frontDocumentImage")}
              >
                {!!state.frontDocumentImage ? (
                  <CustomIonImage imgpath={state.frontDocumentImage} />
                ) : (
                  <IonImg src={"/images/add.svg"} />
                )}
                {!!state.frontDocumentImage && (
                  <IonImg
                    src={"/images/close-icon.svg"}
                    className="document-remove-icon"
                    onClick={() => handleChange("frontDocumentImage", "")}
                  />
                )}
                {!!!state.frontDocumentImage && (
                  <IonLabel color="tertiary" className="upload-side">
                    {constants.UPLOAD_FRONT}
                  </IonLabel>
                )}
                <input
                  type="file"
                  className="input_type_file"
                  accept=".png , .jpg, .pdf"
                  onChange={(event: any) => {
                    handleFileUpload(event, "frontDocumentImage");
                    event.target.value = null;
                  }}
                />
              </div>
              <div
                className="upload-rc-documents"
                onClick={() => AccessNativeCamera("backDocumentImage")}
              >
                {" "}
                {!!state.backDocumentImage ? (
                  <CustomIonImage imgpath={state.backDocumentImage} />
                ) : (
                  <IonImg src={"/images/add.svg"} />
                )}
                {!!state.backDocumentImage && (
                  <IonImg
                    src={"/images/close-icon.svg"}
                    className="document-remove-icon"
                    onClick={() => handleChange("backDocumentImage", "")}
                  />
                )}
                {!!!state.frontDocumentImage && (
                  <IonLabel color="tertiary" className="upload-side">
                    {constants.UPLOAD_BACK}
                  </IonLabel>
                )}
                <input
                  type="file"
                  className="input_type_file"
                  accept=".png , .jpg, .pdf"
                  onChange={(event: any) => {
                    handleFileUpload(event, "backDocumentImage");
                    event.target.value = null;
                  }}
                />
              </div>
            </div>
            <IonLabel className="accepted-formats">{constants.FORMATS_ACCEPTED}</IonLabel>
          </div>
        </div>
        <div className="btn_parent_div document-save-button ">
          <IonButton className=" child_btn" color="primary" onClick={() => saveDocuments()}>
            <IonLabel color="customwhite">{constants.SAVE}</IonLabel>
          </IonButton>
        </div>
      </div>
    </IonCol>
  );
};

export default connect(
  ({ auth, userInfo: { userDocumentsList } }: any) => ({
    ...auth,
    userDocumentsList,
  }),
  { updateUserDocuments, userDocuments, updateUserVehicleDocuments },
)(AddPUCC);
